import React, { useState } from "react";
import { IconButton } from "sprint-common-web";

export interface RefreshButtonProps {
    tooltip?: string;
    disabled?: boolean;
    onClick(): Promise<void>;
}

export const RefreshButton: React.VFC<RefreshButtonProps> = ({ tooltip, disabled, onClick }: RefreshButtonProps) => {
    const [isExecuting, setIsExecuting] = useState<boolean>(false);

    const handleOnClick = async () => {
        setIsExecuting(true);

        try {
            await onClick();
        } finally {
            setIsExecuting(false);
        }
    };

    return (
        <IconButton
            tooltipContent={tooltip ?? "Refresh"}
            iconProps={{ iconName: "Refresh" }}
            disabled={disabled ?? isExecuting}
            onClick={handleOnClick}
        />
    );
};
